"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterval = void 0;
var react_1 = require("react");
exports.useInterval = function (time, action) {
    react_1.useEffect(function () {
        var interval = setInterval(function () {
            action();
        }, time);
        return function () { return clearInterval(interval); };
    }, []);
};
